import DefaultLayout from "./DefaultLayout";
import LoginLayout from "./LoginLayout";
import RegisterLayout from "./RegisterLayout";
import StaticPageLayout from "./StaticPageLayout";
import SwitchLayout from "./SwitchLayout";

export default { DefaultLayout, LoginLayout, RegisterLayout, StaticPageLayout, SwitchLayout };
